module.exports = __webpack_public_path__ + "static/COMS_desktop_logo-da4c439ad646310da93cde6b54478b9b.svg";